import { gql, useApolloClient, useQuery } from '@apollo/client';
import {
  GetArticleTagsQuery,
  GetArticleTagsQueryVariables,
} from '../../__generated__/queries-web';

export const GET_ARTICLE_TAGS = gql`
  query GetArticleTags(
    $first: UnsignedInt!
    $where: TagFilterInput!
    $orderBy: [TagOrderingInput!]
  ) {
    tags(first: $first, where: $where, orderBy: $orderBy) {
      id
      title
      type
    }
  }
`;

export const useGetTags = (variables: GetArticleTagsQueryVariables) =>
  useQuery<GetArticleTagsQuery, GetArticleTagsQueryVariables>(
    GET_ARTICLE_TAGS,
    {
      variables,
    },
  );

export const useArticleTagsGetter = () => {
  const client = useApolloClient();

  return (variables: GetArticleTagsQueryVariables) =>
    client
      .query<GetArticleTagsQuery, GetArticleTagsQueryVariables>({
        query: GET_ARTICLE_TAGS,
        variables,
      })
      .then(({ data, errors }) => {
        if (errors?.length) {
          throw errors[0];
        }

        return data?.tags;
      });
};
